var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClauseSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1141_742",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1141_742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42313 17.0834C4.00215 17.0834 3.64583 16.9376 3.35417 16.6459C3.0625 16.3542 2.91667 15.9979 2.91667 15.577V4.42321C2.91667 4.00223 3.0625 3.64591 3.35417 3.35425C3.64583 3.06258 4.00215 2.91675 4.42313 2.91675H13.1571L17.0833 6.843V15.577C17.0833 15.9979 16.9375 16.3542 16.6458 16.6459C16.3542 16.9376 15.9978 17.0834 15.5769 17.0834H4.42313ZM4.42313 15.8334H15.5769C15.6517 15.8334 15.7132 15.8094 15.7613 15.7613C15.8093 15.7133 15.8333 15.6518 15.8333 15.577V7.50008H12.5V4.16675H4.42313C4.34826 4.16675 4.28681 4.19078 4.23875 4.23883C4.19069 4.28689 4.16667 4.34835 4.16667 4.42321V15.577C4.16667 15.6518 4.19069 15.7133 4.23875 15.7613C4.28681 15.8094 4.34826 15.8334 4.42313 15.8334ZM6.04167 13.7501H13.9583V12.5001H6.04167V13.7501ZM6.04167 7.50008H10V6.25008H6.04167V7.50008ZM6.04167 10.6251H13.9583V9.37508H6.04167V10.6251Z",
    fill: "black",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClauseSummary);
export default __webpack_public_path__ + "static/media/clauseSummary.77360c43ec617c4ceffa5adcb6ae6c30.svg";
export { ForwardRef as ReactComponent };